import { render, staticRenderFns } from "./commonUrl.vue?vue&type=template&id=56105d6c&scoped=true&"
import script from "./commonUrl.vue?vue&type=script&lang=js&"
export * from "./commonUrl.vue?vue&type=script&lang=js&"
import style0 from "./commonUrl.vue?vue&type=style&index=0&id=56105d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56105d6c",
  null
  
)

export default component.exports